var map = {
	"./ai-brain.svg": "/2j+",
	"./ai-customer-satisfaction.svg": "91ao",
	"./ai-innovation.svg": "CQDM",
	"./ai-productivity-time-save.svg": "BFN4",
	"./ai.svg": "8ARr",
	"./audience-group-of-users-audience.svg": "jLrt",
	"./blockchain-investment.svg": "mafD",
	"./blockchain.svg": "4b8R",
	"./bulb-idea.svg": "ic2h",
	"./campaign-management.svg": "AB9v",
	"./career-dev.svg": "uiQj",
	"./clicks-impressions.svg": "fp/g",
	"./cloud-services-iot.svg": "gd7r",
	"./cloud-services.svg": "DBmj",
	"./company-investment.svg": "5sOs",
	"./company-people.svg": "qeiF",
	"./company-security.svg": "sKFS",
	"./company-supply.svg": "1rkM",
	"./company-sustainability.svg": "10TI",
	"./company.svg": "t8Uo",
	"./cta-outline.svg": "ORCV",
	"./cybersecurity-investment.svg": "6wOb",
	"./cybersecurity-phishing.svg": "l1Nt",
	"./cybersecurity-shortage.svg": "XEH9",
	"./cybersecurity.svg": "XUg7",
	"./data-management-ehrs-campaigns.svg": "hQnk",
	"./databank-server.svg": "IuiQ",
	"./deal-hands.svg": "AcAX",
	"./digital-achievement.svg": "pkRO",
	"./digital-cloud-blockchain.svg": "+SHa",
	"./digital-finance-investment.svg": "OHx3",
	"./digital-supply-sustaibnability.svg": "ahLr",
	"./digital-transformation-competitive-edge.svg": "KQmc",
	"./digital-transformation-global.svg": "z5pU",
	"./diversity.svg": "SOP7",
	"./engagement-impressions.svg": "nnJd",
	"./events-lanyard.svg": "tn3w",
	"./facebook-outline.svg": "3IWI",
	"./global.svg": "3Pv+",
	"./graph-audience.svg": "rRN8",
	"./graph-screen.svg": "0C6x",
	"./graph-supply.svg": "gRTI",
	"./growth-graph.svg": "5TBJ",
	"./innovation-generation.svg": "7z15",
	"./investments-positive-return-graph.svg": "ZZbJ",
	"./investments-positive-return.svg": "dvmv",
	"./linkedin-outline.svg": "2QXO",
	"./magazines-spread-reports.svg": "e5XT",
	"./medical.svg": "dzKn",
	"./mentoring-chat-bubbles.svg": "qoTp",
	"./mic-speakers.svg": "h69Y",
	"./newsletters.svg": "hYkt",
	"./omnichannel-banking.svg": "1Wxj",
	"./pin-location.svg": "BoVa",
	"./presentation-graph.svg": "+cmX",
	"./puzzle-bit.svg": "e1mZ",
	"./remote-work-global.svg": "YSXC",
	"./renewable-energy-mining-evs.svg": "IGfI",
	"./shortage-underskilled.svg": "+hC7",
	"./smart-manufactoring.svg": "o1+j",
	"./social-bubbles.svg": "yVc3",
	"./social-phone.svg": "KmSo",
	"./success-badge.svg": "5oIQ",
	"./success-star-audience.svg": "arJq",
	"./supply-chain-digital.svg": "x8Ex",
	"./supply-chain-disruption.svg": "WqC+",
	"./supply-chain-global.svg": "nWDs",
	"./supply-innovation.svg": "kJF4",
	"./supply-management.svg": "dwJK",
	"./support-anywhere-anytime.svg": "3N7h",
	"./sustainability-buying.svg": "d/gQ",
	"./sustainability-carbon-neutrality.svg": "bxc/",
	"./sustainability-finance.svg": "1Xih",
	"./sustainability-green-materials.svg": "3+KJ",
	"./sustainability-innovation.svg": "YGqL",
	"./sustainability-reports-transparency.svg": "Jwn3",
	"./unique-users-screen.svg": "+e56",
	"./webinar-screen.svg": "PjBe",
	"./webinars.svg": "QDwD",
	"./work-life-balance.svg": "kCF3",
	"./world-web.svg": "jfIS",
	"./x-outline.svg": "eeT2",
	"./youtube-outline.svg": "IUoX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fAMM";